import { USER_ROLE } from '../types/user-role.type';
import { UserDto } from './user.dto';

export class User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    role: USER_ROLE;

    constructor(data: UserDto) {
        this.id = data.id;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.role = data.role;
    }
}
